export default "__VITE_ASSET__df08105e__"